import * as SimstreamConstants from '../constants';
import * as D from '../deps';

import SimStreamWorkers from './workers';

export default [
  {
    actionType: 'OPEN_SIM_STREAM_MODAL',
    handler: SimStreamWorkers.openSimStreamModal,
    concur: 'takeEvery',
  },
  {
    actionType: SimstreamConstants.ActionKeys.LET_ME_LISTEN,
    handler: SimStreamWorkers.letMeListen,
    concur: 'takeEvery',
  },
  {
    actionType: SimstreamConstants.ActionKeys.LET_THEM_LISTEN,
    handler: SimStreamWorkers.letThemListen,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.INSERT_NEW_SIM_STREAM_VIOLATION,
    handler: SimStreamWorkers.insertNewSimStreamViolation,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REQUEST_PLAY_TRACK,
    handler: SimStreamWorkers.onPlayTrack,
    concur: 'takeEvery',
  },
];
